export const AGENT_ORDER_SEED_PARAM = "order";
export const AGENT_ORDER_SEED_HEADER = "x-agent-order-seed";

const AGENT_ORDER_SEED_PATTERN = /^[0-9a-f]{32}$/;

/** Accept only the non-PII 128-bit seed format issued by the middleware. */
export function parseAgentOrderSeed(value: string | undefined): string | null {
  return value && AGENT_ORDER_SEED_PATTERN.test(value) ? value : null;
}

/** Create a fresh result sequence without user or agent data. */
export function createAgentOrderSeed(): string {
  return crypto.randomUUID().replaceAll("-", "");
}
